import { Component, inject } from '@angular/core';
import { FASDynamicTableColumnConfig } from 'fas-services';
import { MyOskStudentsService } from '../../../../api/api-services/my-osk-students.service';
import { map, Observable } from 'rxjs';
import { SortOrder } from '../../../../api/sort-order.model';
import { getSubscriptionStatus } from '../../../shared/helpers/subscription-status';
import { IMyOskStudentVm } from '../../../../api/my-osk-student-vm.model';

@Component({
  selector: 'app-students-list-archived',
  templateUrl: './students-list-archived.component.html',
  styleUrl: './students-list-archived.component.scss'
})
export class StudentsListArchivedComponent {
  private _myOskStudentsService = inject(MyOskStudentsService);


  public columns: FASDynamicTableColumnConfig<IMyOskStudentVm>[] = [
    {
      field: 'displayName',
      columnHeader: 'Nazwa użytkownika (Imię i Nazwisko)',
    },
    {
      field: 'created',
      dateField: true,
      columnHeader: "Data utworzenia"
    },
    {
      field: 'email',
      columnHeader: 'Adres email'
    },
    {
      field: 'oskPlatformSubscriptionPlan',
      columnHeader: 'Wykupiony pakiet',
      columnTemplateKey: 'subscriptionPlanTemp'
    },
    {
      field: 'validTo',
      columnHeader: 'Status pakietu',
      columnTemplateKey: 'subscriptionPlanStatusTemp'
    },
  ];

  fetchOskStudentsArchivedList = (params: {
    page: number;
    pageSize: number;
    sortField?: keyof IMyOskStudentVm;
    sortOrder?: number;
    search?: string;
  }): Observable<{ data: IMyOskStudentVm[]; total: number }> => {
    const { page, pageSize, sortField = '', sortOrder, search = '' } = params;
    const sortOrderValue =
      sortOrder === 1 ? SortOrder.Ascending : SortOrder.Descending;
    return this._myOskStudentsService
      .get(true, search, sortField, page, pageSize, )
      .pipe(
        map((result) => ({
          data: result.data ?? [],
          total: result.allElementsCount,
        }))
      );
  };

    getStatus(subscriptionDate?: Date): { status: string; color: string } {
      return getSubscriptionStatus(subscriptionDate)
    }
}
